import { render, staticRenderFns } from "./profile-view-documents-attach.vue?vue&type=template&id=4b8bd374&scoped=true&"
import script from "./profile-view-documents-attach.vue?vue&type=script&lang=js&"
export * from "./profile-view-documents-attach.vue?vue&type=script&lang=js&"
import style0 from "./profile-view-documents-attach.vue?vue&type=style&index=0&id=4b8bd374&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8bd374",
  null
  
)

export default component.exports